// test40
(40 && 0);
